import { Svg } from "../../Pages/Components/Utils/Svg";
import { Icons } from "../Utils/Icons";


export class SearchIcon extends Svg
{
    constructor()
    {
        super(Icons.Search);
    }
}
